/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { ContactTitle } from "../components/ContactTitle";
import { ContactForm } from "../components/ContactForm";
import { ContactInformation } from "../components/ContactInformation";
import { Helmet } from "react-helmet";

export const Contact: React.FC = () => {
    return(
        <>
            <Helmet>
                <title>Contact Us - Jewish Cemetery</title>
                <meta name="description" content="This website was designed by the Jewish Cemeteries Maintenance Board to pay tribute to loved ones that are no longer with us." />
            </Helmet>

            <div className="jc-grid mx-auto" style={{maxWidth: "1028px"}}>
                <ContactTitle />

                <div className="row">
                    <div className="col-md-6 pe-4 contact-col-border">
                        <ContactForm />
                        <hr className="contact-break" />
                    </div>

                    <div className="col-md-6 ps-4">
                        <div className="row">
                            <ContactInformation />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}